export const regexForm = {
    celular: /\([0-9]{2}\) [0-9]{1} [0-9]{4}-[0-9]{4}$/,
    telefone: /\([0-9]{2}\) [0-9]{4}-[0-9]{4}$/,
    contato: /\([0-9]{2}\)( [0-9])? [0-9]{4}-[0-9]{4}$/,
    cpf: /([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})/,
    cnpj: /([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})/,
    registro:
        /([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})/,
    senha: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W|_)(?=.{8,})/,
    real: /^R\$\s?((\d{1,3}\.)+)?(\d{1,3},)(\d{2})$/,
    cep: /^[0-9]{5}(-)?[0-9]{3}/
}
